import { TabMode } from "widgets/mobileIndex/lib/hooks/useMobileIndex";
import { FC } from "react";
import { MobileIndexWait } from "../wait";
import { MobileIndexPlace } from "../place";
import { MobileIndexSitting } from "../sitting";

interface MobileIndexBodyProps {
  tabMode: TabMode;
  isLoaded: boolean
}

export const MobileIndexBody: FC<MobileIndexBodyProps> = ({
  tabMode,
  isLoaded
}) => {
  switch (tabMode) {
    case 'wait':
      return <MobileIndexWait />
    case 'place':
      return <MobileIndexPlace isLoaded={isLoaded}/>
    case 'sitting':
      return <MobileIndexSitting />
  
    default:
      return <MobileIndexWait />
  }
  
}